import React from 'react'
import styled from '@emotion/styled'

import { Flex } from 'lese'
import { ModalCard, closeModal } from 'Components/Modal'
import { X } from 'react-feather'
import config from 'Config'

import Print from '../Print'

const PrintContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export default ({ PMHID, token, isExternal, id }) => {
  return (
    <ModalCard>
      <PrintContainer>
        <Print encounter={{ PMHID, token, isExternal, id }} />
        <X style={{ cursor: 'pointer' }} strokeWidth="1px" size="40px" onClick={closeModal} />
      </PrintContainer>
      {isExternal && PMHID && (
        <object
          data={`${config.docportal.getUrl()}/docportal_api/services/get_ts_file.php?PMHID=${PMHID}&token=${token}`}
          key={PMHID}
          width={999}
          height={800}
        >
          PDF Document {/* TODO: Better aria-label */}
        </object>
      )}
      {!isExternal && PMHID && (
        <object
          data={`${config.docportal.getUrl()}/docportal/#/getFaxReport/${PMHID}?token=${token}`}
          key={PMHID}
          width={999}
          height={800}
        >
          PDF Document {/* TODO: Better aria-label */}
        </object>
      )}
    </ModalCard>
  )
}
